import React from 'react';
// Importamos de 24/outline solo para el ClockIcon
import { ClockIcon as HeroClockOutline } from '@heroicons/react/24/outline';

// Importamos de 20/solid para los demás iconos
import {
  MagnifyingGlassIcon as HeroMagnifyingGlass,
  ChevronRightIcon as HeroChevronRight,
  ChevronLeftIcon as HeroChevronLeft,
  Cog6ToothIcon as HeroCog6Tooth,
  ShoppingCartIcon as HeroShoppingCart,
  CubeIcon as HeroCube,
  DocumentIcon as HeroDocument,
} from '@heroicons/react/20/solid';

/**
 * Iconos estándar para NavigationRailGroup
 * Basados en Heroicons 20x20 solid (excepto ClockIcon que es 24x24 outline)
 * Consistente con NavigationRailTypes
 *
 * @see docs/icons.md - Sistema de iconos del proyecto
 */

export const MagnifyingGlassIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroMagnifyingGlass className={className} aria-hidden="true" />
);

export const ChevronRightIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroChevronRight className={className} aria-hidden="true" />
);

export const ChevronLeftIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroChevronLeft className={className} aria-hidden="true" />
);

export const Cog6ToothIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroCog6Tooth className={className} aria-hidden="true" />
);

export const ShoppingCartIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroShoppingCart className={className} aria-hidden="true" />
);

export const CubeIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroCube className={className} aria-hidden="true" />
);

export const DocumentIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroDocument className={className} aria-hidden="true" />
);

export const ClockIcon: React.FC<{ className?: string }> = ({ className = 'size-4' }) => (
  <HeroClockOutline className={className} aria-hidden="true" />
);
